import styled from "styled-components";

export const StyledSSCBlockContainer = styled.div<{isMobile?: boolean}>`
  flex-grow: 1;
  max-width: ${(props) => (props.isMobile ? 50 : 45)}%;
  //border: 1px solid #f14af3; // Debugging purposes
`;
